import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AvatarPersona } from "@/components/ui/avatar-persona";
import { useAvatarVista } from "@/hooks/useAvatarVista";
import { usePerfilVista } from "@/hooks/usePerfilVista";
import { UserSettingsDialog } from "./UserSettingsDialog";

/**
 * Avatar de quien se está viendo en el encabezado (foto o iniciales) que abre su cuenta. Es la
 * identidad efectiva, la misma del pie del menú (`usePerfilVista` + `useFotoPerfilVista`):
 * - Sin "Ver como": la sesión y abre "Mi cuenta" (`UserSettingsDialog`).
 * - Con "Ver como": la persona vista y abre el mismo modal con SUS datos, en solo lectura
 *   (`UserSettingsDialog` lo resuelve con el target de impersonación).
 * Fuente única del avatar de los encabezados: AdminHeader y los portales lo usan.
 */
export function BotonMiCuenta() {
  const perfil = usePerfilVista();
  const avatar = useAvatarVista();
  const [abierto, setAbierto] = useState(false);
  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        // shrink-0: junto a un "Ver como" ancho el botón se encogía a cero y el avatar desaparecía.
        className="shrink-0"
        aria-label={perfil.impersonando ? `Cuenta de ${perfil.nombre} (solo lectura)` : "Mi cuenta"}
        onClick={() => setAbierto(true)}
      >
        <AvatarPersona nombre={avatar.nombre} fotoUrl={avatar.fotoUrl} cargando={avatar.cargando} enLinea={avatar.enLinea} ultimaActividad={avatar.ultimaActividad} size="sm" />
      </Button>
      <UserSettingsDialog open={abierto} onOpenChange={setAbierto} />
    </>
  );
}
